export default "skymp5-front/335fe1d84b2984168318d136b5296c21.jpg";